import request from '../../request.js'
//e签宝 合同模板维护

//查询模板列表
export const getPageTableList = function (data) {
    return request({
        url: '/esignTemplate/list',
        method: 'post',
        data
    })
}

//创建模板
export const docTemplateCreateUrl = function (data) {
    return request({
        url: '/esignTemplate/docTemplateCreateUrl',
        method: 'post',
        data
    })
}

//删除
export const deleteByDocTemplateId = function (data) {
    return request({
        url: '/esignTemplate/deleteByDocTemplateId',
        method: 'post',
        data
    })
}

//获取模板编辑地址
export const docTemplateEditUrl = function (data) {
    return request({
        url: '/esignTemplate/docTemplateEditUrl',
        method: 'post',
        data
    })
}

//查询合同模板列表----郑勇
export const getTemplateList = function (data) {
    return request({
        url: '/esignTemplate/list',
        method: 'post',
        data
    })
}

//业务对接-添加模板-暂存/下一步---郑勇
export const addTemplateFromHtml = function (data) {
    return request({
        url: '/esignTemplate/addTemplateFromHtml',
        method: 'post',
        data
    })
}

//业务对接-添加模板-根据ID获取信息----郑勇
export const getInfoById = function (data) {
    return request({
        url: '/esignTemplate/getInfoById',
        method: 'post',
        data
    })
}

//业务对接-添加模板-保存/更新 信息----郑勇
export const saveOrUpdate = function (data) {
    return request({
        url: '/esignTemplate/saveOrUpdate',
        method: 'post',
        data
    })
}

//业务对接-添加模板-获取码表----郑勇
export const getDict = function (data) {
    return request({
        url: '/esignTemplate/getDict',
        method: 'post',
        data
    })
}

//业务对接-根据模板ID删除模板----郑勇
export const delTemp = function (data) {
    return request({
        url: '/esignTemplate/deleteByDocTemplateId',
        method: 'post',
        data
    })
}

//业务对接-添加模板-获取聚易厅业务字段----张环
export const getJytTemplateConfig = function (data) {
    return request({
        baseURL:process.env.VUE_APP_PROJECT_JUYI_URL,
        url: 'contract/getTemplateConfig',
        method: 'post',
        data
    })
}
//业务对接-添加模板-获取租赁通业务字段----崔北超
export const getZltTemplateConfig = function (data) {
    return request({
        baseURL:process.env.VUE_APP_PROJECT_ZULIN_URL,
        url: 'contract/getTemplateConfig',
        method: 'post',
        data
    })
}